/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/

import {lang, sessid, axiosConfig,  eventEmitter}  from './common/baseData'
import './blog/style.css'
import './blog/blog-list/style.css'
import './pagenavigation/style.css'
import './catalog/filter/style.css'

import React, { Suspense, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import LoadingBlock from './components/loadingBlock'
import RubricList from './components/blog/rubricList/RubricList'
import BlogListVertical from './components/blog/blogListVertical/BlogListVertical'
import BlogFilter from './components/blog/blogFilter/BlogFilter'
import BlogListHorizontal from './components/blog/blogListHorizontal/BlogListHorizontal'
import axios from 'axios'
import {createRoot} from 'react-dom/client';

let appRootNode = document.getElementById('blog-app-root')

let params = {
  "rubric": rubricData,
  "rubricParams": rubricParams,
  "titleBlock": titleBlock,
  "filterMess": filterMess,
  "filterData": filterData,
  "filterParams": filterParams,
  "newsList": newsList,
  "newsListParams": newsListParams,
  "blogUrl": blogUrl,
}

// Blog App
const blogApp = createRoot(appRootNode)
blogApp.render(<BlogListApp {...params}/>)

function BlogListApp (props) {
  const [rubrics, setRubrics] = useState(props.rubric)
  const [loaded, setLoaded] = useState(true)
  const [mainList, setMainList] = useState(props.newsList)
  const [mainListParams, setMainListParams] = useState(props.newsListParams)
  const [mainListFilter, setMainListFilter] = useState(props.newsListParams.filter)
  const [authorInfo, setAuthorInfo] = useState(props.newsListParams.params.AUTHOR_INFO)
  const [authorCode, setAuthorCode] = useState(props.newsListParams.params.AUTHOR_CODE)
  const [filters, setFilters] = useState(props.filterData)
  const [filterParams, setFilterParams] = useState(props.filterParams)
  const [filterSelectedValue, setFilterSelectedValue] = useState(props.filterParams.dataFilterSection)
  const [filterSelectedValueName, setFilterSelectedValueName] = useState(props.filterParams.dataFilterSectionNames)
  const [filterSectionCodes, setFilterSectionCodes] = useState(props.filterParams.sectionCodes)
  const [rubricParams, setRubricParams] = useState(props.rubricParams)
  const [rubricSelectedValue, setRubricSelectedValue] = useState(props.rubricParams.selectedValue)
  const [titleBlock, setTitleBlock] = useState(props.titleBlock)
  const [filterMess, setFilterMess] = useState(props.filterMess)
  const [robotsParams, setRobotsParams] = useState(props.newsList.metaParams)
  const [filterOpened, setFilterOpened] = useState(false);

  useEffect(() => {
    // Добавляем текущий URL в историю
    window.history.pushState({ url: window.location.href }, null, window.location.href);

    const filterSelectedValueNamesString = filterSelectedValueName.length > 0
        ? `, ${filterSelectedValueName.join(', ')}`
        : '';

    setTitleBlock(`${props.titleBlock}${filterSelectedValueNamesString}`);
  }, [props.filterParams.dataFilterSectionNames, props.titleBlock]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const filterSection = document.querySelector('.filter-section');
      const bg = document.querySelector('.bg');

      // Проверяем, что фильтр открыт и клик произошел по фону
      if (filterSection && filterSection.classList.contains('opened') &&
        event.target === bg) {
        filterSection.classList.remove('opened');
        bg.classList.remove('active');
        document.querySelector('body').classList.remove('side-open');
        eventEmitter.emit('filterToggle', false);
      }
    };

    // Добавляем обработчик
    document.addEventListener('click', handleClickOutside);

    // Убираем обработчик при размонтировании
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  function updateBreadcrumbs(activeRubricName) {
    const breadcrumbsList = document.querySelector('.breadcrumbs-list');

    if (breadcrumbsList) {
        const breadcrumbItems = breadcrumbsList.querySelectorAll('li');

        if (breadcrumbItems.length > 2) {
            // Удаляем все элементы, начиная с третьего
            for (let i = 2; i < breadcrumbItems.length; i++) {
                breadcrumbsList.removeChild(breadcrumbItems[i]);
            }
        }

        // добавляем ссылку на Блог в хлебной крошке
        if (breadcrumbItems.length === 2) {
          console.log(props)
          let blogUrl = document.createElement('a')
          blogUrl.textContent = breadcrumbItems[1].textContent
          blogUrl.href = props.blogUrl.url
          breadcrumbItems[1].textContent = '';
          breadcrumbItems[1].appendChild(blogUrl)
        }

        if (activeRubricName) {
            // Создаем новый элемент li с содержимым activeRubric.NAME
            const newBreadcrumb = document.createElement('li');
            newBreadcrumb.textContent = activeRubricName;

            // Добавляем новый элемент в конец breadcrumbs-list
            breadcrumbsList.appendChild(newBreadcrumb);
        }
    }
  }

  function onCategoryChange (categoryID, categoryName) {

    // Проверяем, присутствует ли categoryID в filterSelectedValue
      const isCategorySelected = filterSelectedValue.includes(categoryID);

      // Создаем новый массив для обновленных значений
      let updatedFilterSelectedValue;
      let updatedFilterSelectedValueName;

      // Если categoryID присутствует, удаляем его из массива
      if (isCategorySelected) {
          updatedFilterSelectedValue = filterSelectedValue.filter(id => id !== categoryID);
          updatedFilterSelectedValueName = filterSelectedValueName.filter(id => id !== categoryName);

      } else {
          // Если categoryID отсутствует, добавляем его в массив
          updatedFilterSelectedValue = [...filterSelectedValue, categoryID];
          updatedFilterSelectedValueName = [...filterSelectedValueName, categoryName];
      }

    // Начало загрузки
    eventEmitter.emit('showLoader')

    Promise.all([getRubrics(), getMainArticles({'=PROPERTY_CATEGORY':updatedFilterSelectedValue}, {"page":1})])
        .then(results => {
          setRubrics({...results[0].data})
          setMainList({...results[1].data})
          setFilterSelectedValue(updatedFilterSelectedValue)
          setFilterSelectedValueName(updatedFilterSelectedValueName)
          setMainListFilter({'=PROPERTY_CATEGORY':categoryID,"=PROPERTY_RUBRIC":rubricSelectedValue})
          setAuthorInfo(null)
          setAuthorCode(null)
          setLoaded(true)

          // Проверяем, не пуст ли массив updatedFilterSelectedValueName
          const filterSelectedValueNamesString = updatedFilterSelectedValueName.length > 0
            ? `, ${updatedFilterSelectedValueName.join(', ')}`
            : '';

          setTitleBlock(`${props.titleBlock}${filterSelectedValueNamesString}`);
          updateBreadcrumbs();

          eventEmitter.emit('hideLoader')
        })
  }

  function onRubricsChange (rubricCode) {

    // Начало загрузки
    eventEmitter.emit('showLoader')

    Promise.all([getRubrics(rubricCode), getMainArticles({'=PROPERTY_CATEGORY':null,"=PROPERTY_RUBRIC":rubricCode})])
        .then(results => {
          setRubrics({...results[0].data})
          setMainList({...results[1].data})
          setRubricSelectedValue(rubricCode)
          setFilterSelectedValue([])
          setFilterSelectedValueName([])
          setAuthorInfo(null)
          setAuthorCode(null)
          setMainListFilter({'=PROPERTY_CATEGORY': [],"=PROPERTY_RUBRIC":rubricCode})
          setLoaded(true)

          // Найти объект с "ACTIVE": true и вызвать setTitleBlock() на его "NAME"
          const activeRubric = results[0].data.rubrics.find(rubric => rubric.ACTIVE === true);
          if (activeRubric) {
            setTitleBlock(`#${activeRubric.NAME}`);

            updateBreadcrumbs(activeRubric.NAME);
          }
          eventEmitter.emit('hideLoader')
        })
  }

  function onPagerChange (pagerCode) {

    // Начало загрузки
    eventEmitter.emit('showLoader')

    Promise.all([getRubrics(rubricSelectedValue), getMainArticles({'=PROPERTY_CATEGORY':filterSelectedValue,"=PROPERTY_RUBRIC":rubricSelectedValue},{"page":pagerCode}, {"author_code":authorCode})])
        .then(results => {
          setRubrics({...results[0].data})
          setMainList({...results[1].data})
          setLoaded(true)

          // Найти объект с "ACTIVE": true и вызвать setTitleBlock() на его "NAME"
          const activeRubric = results[0].data.rubrics.find(rubric => rubric.ACTIVE === true);
          if (activeRubric) {
            setTitleBlock(`#${activeRubric.NAME}`);
          }
          eventEmitter.emit('hideLoader')
        })
  }

  function onAuthorChange (authorCode) {

    // Начало загрузки
    eventEmitter.emit('showLoader')

    Promise.all([getRubrics(rubricSelectedValue), getMainArticles({},{"page":1}, {"author_code":authorCode})])
        .then(results => {
          setRubrics({...results[0].data})
          setMainList({...results[1].data})
          setAuthorInfo(results[1].data.author)
          setAuthorCode(authorCode)
          setMainListFilter({'=PROPERTY_CATEGORY': [],"=PROPERTY_RUBRIC":null})
          setFilterSelectedValue([])
          setFilterSelectedValueName([])
          setLoaded(true)

          setTitleBlock(`${results[1].data.author.UF_TITLE_NAME}`);
          updateBreadcrumbs(results[1].data.author.UF_TITLE_NAME);
          eventEmitter.emit('hideLoader')
        })
  }

  function getRubrics (selectedValue) {
    let data = {
      sessid: sessid,
      lang: lang,
      selectedValue: selectedValue,
    }

    return axios.post(`${rubricParams.asyncUrl}`, data, axiosConfig)
  }

  function getFilter (dataFilter) {
      let data = {
        sessid: sessid,
        lang: lang,
        filterProperty: ["CATEGORY"],
        filter: dataFilter,
      }

     return axios.post(`${filterParams.asyncUrl}`, data, axiosConfig)
  }

  function getMainArticles (mainListFilter, nav, author) {
    let data = {
      sessid: sessid,
      lang: lang,
      filter: mainListFilter,
      params: mainListParams.params,
      nav_params: nav,
      author: author,
    }

    // Отправляем
    return axios.post(`${mainListParams.asyncUrl}`, data, axiosConfig)
  }

  const handleMobileFilter = (event) => {
    event.preventDefault(); // Предотвращаем стандартное действие перехода по ссылке

    var filterSection = document.querySelector('.filter-section');
    let bg = document.querySelector('.bg');
    const isOpened = !filterSection.classList.contains('opened');

    if (!filterSection.classList.contains('opened')) {
        // Показываем блок
        filterSection.classList.add('opened');
        bg.classList.add('active');
        bg.style.zIndex = 1066;
        document.querySelector('body').classList.add('side-open');
    } else {
        // Скрываем блок
        filterSection.classList.remove('opened');
        bg.classList.remove('active');
        bg.style.zIndex = 3;
        document.querySelector('body').classList.remove('side-open');
    }

    eventEmitter.emit('filterToggle', isOpened);
  }

  // Функция для замены значения тега <meta name="og:title">
  function updateOgTitle(newTitle) {
    const ogTitleTag = document.querySelector('meta[name="og:title"]');
    if (ogTitleTag) {
        ogTitleTag.content = newTitle;
    }
  }

  // Функция для замены значения тега <title>
  function updateTitle(newTitle) {
    const titleTag = document.querySelector('title');
    if (titleTag) {
        titleTag.innerText = newTitle;
    }
  }

  // Функция для замены значения тега <h1>
  function updateHTitle(newTitle) {
    const titleTag = document.querySelector('h1');
    if (titleTag) {
        titleTag.innerText = newTitle;
    }
  }

  // Функция для замены значения тега <meta name="description">
  function updateMetaDescription(newDescription) {
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    if (metaDescriptionTag) {
        metaDescriptionTag.content = newDescription;
    }

    const ogDescriptionTag = document.querySelector('meta[name="og:description"]');
    if (ogDescriptionTag) {
        ogDescriptionTag.content = newDescription;
    }
  }

  // Функция для замены значения тега <meta name="keywords">
  function updateMetaKeywords(newKeywords) {
    const metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    if (metaKeywordsTag) {
        metaKeywordsTag.content = newKeywords;
    }
  }

  // Функция для замены значения тега <meta name="robots">
  function updateMetaRobots(newKeywords) {
    const metaKeywordsTag = document.querySelector('meta[name="robots"]');
    if (metaKeywordsTag) {
        metaKeywordsTag.content = newKeywords;
    }
  }

  const setLangLink = (newLink) => {

    //Делаем запрос на изменение meta на странице
    let data = {
      sessid: sessid,
      lang: lang,
      link: newLink,
    }
    // Отправляем
    axios.post(`${mainListParams.asyncMetaUrl}`, data, axiosConfig).then(results => {
        for (const key in results.data) {
            if (typeof results.data[key] === 'string') {
                switch (key) {
                    case 'title':
                        updateOgTitle(results.data[key]);
                        updateTitle(results.data[key]);
                        break;
                    case 'description':
                        updateMetaDescription(results.data[key]);
                        break;
                    case 'keywords':
                        updateMetaKeywords(results.data[key]);
                        break;
                    case 'h1':
                        updateHTitle(results.data[key]);
                        break;
                    case 'robots':
                        updateMetaRobots(results.data[key]);
                        setRobotsParams(results.data[key])
                        break;
                }
            }
        }
    })

    // Находим div с классом "languages"
    var languagesDiv = document.querySelector('.languages');
    // Проверяем, найден ли такой div
    if (languagesDiv) {
      // Находим ссылку внутри div
      var link = languagesDiv.querySelector('a');
      var langCode = '';

      if(filterParams.lang == 'ru'){
          langCode = "/ua";
      }
      else {
          var searchString = "/news";
          // Ищем позицию "/news" в строке
          var index = newLink.indexOf(searchString);
         // Если "/news" найден, вырезаем часть строки до этой подстроки
          var newLink = index !== -1 ? newLink.substring(index) : null;
      }

      // Проверяем, найдена ли такая ссылка
      if (link) {
          // Заменяем атрибут href на текущий URL страницы
          link.href = langCode+newLink;
      }
    }
  }

  window.addEventListener('popstate', (event) => {
    if (event.state && event.state.url) {
        window.location.href = event.state.url;
        console.log('Previous URL:', event.state.url);
    }
  });

  return (
    <>
      {
        loaded ?
          <>
            {
              rubrics ?
                  <RubricList {...rubrics} setRubrics={setRubrics} setLangLink={setLangLink} onRubricsChange={onRubricsChange}/> :
                <></>
            }
            <div className="blog">
            {
              titleBlock ?
                  <h1 className="author-title">{titleBlock}</h1>
                  :
                  <></>
            }
            {
                filterMess ?
                    <div className="filter-link">
                        <a href="#"
                           onClick={(event) => handleMobileFilter(event)}
                        >{filterMess}</a>
                    </div>
                    :
                    <></>
            }
            {
              mainList ?
                  <div className="blog-holder">
                    <BlogFilter {...filters}
                                filterSectionSelect={filterSelectedValue}
                                setLangLink={setLangLink}
                                filterSectionCodes={filterSectionCodes}
                                handleMobileFilter={handleMobileFilter}
                                onCategoryChange={onCategoryChange}/>
                    <div className="blog-content">
                      <BlogListVertical {...mainList} onPagerChange={onPagerChange} setLangLink={setLangLink} onRubricsChange={onRubricsChange} onAuthorChange={onAuthorChange} authorInfo={authorInfo} robotsParams={robotsParams}/>
                    </div>
                  </div> :
                <></>
            }
            </div>
          </> :
          <LoadingBlock/>
      }
    </>
  )
}